import * as types from './types';

const INITIAL_STATE = {
  bidGroupData: [],
  bidGroupDataLoading: false,
  bidGroupDataError: null,
  itemGroupData: [],
  itemGroupDataLoading: false,
  itemGroupDataError: null,
  acctCategoryData: [],
  acctCategoryDataLoading: false,
  acctCategoryDataError: null,
  vendorData: [],
  vendorDataLoading: false,
  vendorDataError: null,
  storageLocationData: [],
  storageLocationDataLoading: false,
  storageLocationDataError: null,
  siteGroupData: [],
  siteGroupDataLoading: false,
  siteGroupLoadingError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_BID_GROUP_DATA: {
      const bidGroupData = action.payload.data.Data;
      return {
        ...state,
        bidGroupData,
      };
    }
    case types.FETCH_BID_GROUP_DATA_LOADING: {
      return {
        ...state,
        bidGroupDataLoading: action.payload,
      };
    }

    case types.SET_ITEM_GROUP_DATA: {
      const itemGroupData = action.payload.data.Data;
      return {
        ...state,
        itemGroupData,
      };
    }

    case types.FETCH_ITEM_GROUP_DATA_LOADING: {
      return {
        ...state,
        itemGroupDataLoading: action.payload,
      };
    }
    case types.SET_ACCT_CATEGORY_DATA: {
      const acctCategoryData = action.payload.data.Data;
      return {
        ...state,
        acctCategoryData,
      };
    }
    case types.FETCH_ACCT_CATEGORY_DATA_LOADING: {
      return {
        ...state,
        acctCategoryDataLoading: action.payload,
      };
    }

    case types.SET_VENDOR_DATA: {
      const vendorData = action.payload.data.Data;
      return {
        ...state,
        vendorData,
      };
    }

    case types.FETCH_VENDOR_DATA_LOADING: {
      return {
        ...state,
        vendorDataLoading: action.payload,
      };
    }
    case types.SET_STORAGE_LOCATION_DATA: {
      const storageLocationData = action.payload.data.Data;
      return {
        ...state,
        storageLocationData,
      };
    }
    case types.FETCH_STORAGE_LOCATION_DATA_LOADING: {
      return {
        ...state,
        storageLocationDataLoading: action.payload,
      };
    }
    case types.FETCH_BID_GROUP_DATA_LOADING_ERROR:
      return { ...state, bidGroupDataError: action.payload };

    case types.FETCH_ITEM_GROUP_DATA_LOADING_ERROR:
      return { ...state, itemGroupDataError: action.payload };

    case types.FETCH_ACCT_CATEGORY_DATA_LOADING_ERROR:
      return { ...state, acctCategoryDataError: action.payload };

    case types.FETCH_STORAGE_LOCATION_DATA_LOADING_ERROR:
      return {
        ...state,
        storageLocationDataError: action.payload,
      };

    case types.FETCH_VENDOR_DATA_LOADING_ERROR:
      return { ...state, vendorDataError: action.payload };

    case types.SET_SITE_GROUP_DATA:
      return {
        ...state,
        siteGroupData: action.payload,
      };
    case types.FETCH_SITE_GROUP_DATA:
      return {
        ...state,
        siteGroupDataLoading: action.payload,
      };
    case types.FETCH_SITE_GROUP_DATA_ERROR:
      return {
        ...state,
        siteGroupLoadingError: action.payload,
      };
    case types.CLEAR_ERROR_MSG:
      return {
        ...state,
        itemGroupDataError: null,
        storageLocationDataError: null,
        vendorDataError: null,
        acctCategoryDataError: null,
        bidGroupDataError: null,
        siteGroupLoadingError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/filters/reducer.js